(function(){
  function initRoot(root){
    if(!root || root.dataset.bysInit) return; root.dataset.bysInit='1';
    var DATA=[]; try{ DATA=JSON.parse(root.querySelector('[data-bys-data]').textContent);}catch(e){}
    var DISCOUNT=parseFloat(root.getAttribute('data-discount'))||0;
    var DISCOUNT_CODE=root.getAttribute('data-discount-code')||'';
    var picks={};   // group key -> selected product index
    var vpicks={};  // group key -> selected variant index within that product
    var scrim=root.querySelector('.bys-scrim'), modal=root.querySelector('.bys-modal');
    var groupsWrap=root.querySelector('[data-bys-groups]');
    function money(cents){return '$'+(cents/100).toFixed(2);}
    function esc(s){return (s||'').replace(/"/g,'&quot;');}
    function grpByKey(k){ for(var i=0;i<DATA.length;i++){ if(DATA[i].key===k) return DATA[i]; } return null; }
    // Resolve the currently chosen variant for a group (falls back to first variant).
    function chosenVar(grp){
      var prod=grp.items[picks[grp.key]]; if(!prod) return null;
      var vs=prod.vars||[];
      if(!vs.length) return {id:prod.id,p:prod.p};
      if(vs.length===1) return vs[0];
      var vi=vpicks[grp.key]; if(vi==null||!vs[vi]) vi=0;
      return vs[vi];
    }
    function render(){
      if(!DATA.length){groupsWrap.innerHTML='<div class="bys-empty">Pick a collection for each tab in the theme editor to populate this builder.</div>';return;}
      var n=1, html='';
      DATA.forEach(function(grp){
        if(!grp.items.length) return;
        if(picks[grp.key]==null) picks[grp.key]=0;
        html+='<div><div class="step-label"><span class="sn">'+(n++)+'</span> '+grp.label+'</div><div class="opt-row" data-group="'+grp.key+'">';
        grp.items.forEach(function(o,i){
          html+='<div class="opt'+(i===picks[grp.key]?' sel':'')+'" data-group="'+grp.key+'" data-i="'+i+'">'+
                '<div class="pic">'+(o.img?'<img src="'+o.img+'" alt="'+esc(o.n)+'" loading="lazy">':'')+'</div>'+
                '<div class="nm">'+(o.n||'')+'</div><div class="pr">'+money(o.p)+'</div></div>';
        });
        html+='</div><div class="var-row" data-varrow="'+grp.key+'"></div></div>';
      });
      groupsWrap.innerHTML=html;
      DATA.forEach(function(grp){ if(grp.items.length) renderVar(grp.key); });
      totals();
    }
    // Render a single size/option dropdown next to a group, only when the
    // selected product has more than one variant (rings). Single-variant
    // products (earrings, necklaces) render nothing.
    function renderVar(key){
      var box=groupsWrap.querySelector('[data-varrow="'+key+'"]'); if(!box) return;
      var grp=grpByKey(key); var prod=grp&&grp.items[picks[key]];
      var vs=(prod&&prod.vars)||[];
      if(!prod||vs.length<=1){ box.innerHTML=''; return; }
      if(vpicks[key]==null) vpicks[key]=0;
      var label=prod.opt||'Options';
      var opts='';
      vs.forEach(function(v,i){
        opts+='<option value="'+i+'"'+(i===vpicks[key]?' selected':'')+(v.av?'':' disabled')+'>'+v.t+(v.av?'':' — sold out')+'</option>';
      });
      box.innerHTML='<span class="var-label">'+label+'</span><select class="var-sel" data-varsel="'+key+'" aria-label="'+esc(label)+'">'+opts+'</select>';
    }
    function totals(){
      var sub=0;
      DATA.forEach(function(grp){ if(!grp.items.length) return; var v=chosenVar(grp); if(v) sub+=v.p; });
      var save=Math.round(sub*DISCOUNT/100);
      root.querySelector('[data-bys-subtotal]').textContent=money(sub);
      root.querySelector('[data-bys-savings]').textContent='-'+money(save);
      root.querySelector('[data-bys-total]').textContent=money(sub-save);
    }
    groupsWrap.addEventListener('click',function(e){
      var o=e.target.closest('.opt'); if(!o)return;
      var g=o.dataset.group;
      groupsWrap.querySelectorAll('.opt[data-group="'+g+'"]').forEach(function(x){x.classList.remove('sel');});
      o.classList.add('sel'); picks[g]=+o.dataset.i; vpicks[g]=0; renderVar(g); totals();
    });
    groupsWrap.addEventListener('change',function(e){
      var s=e.target.closest('[data-varsel]'); if(!s)return;
      vpicks[s.dataset.varsel]=+s.value; totals();
    });
    function open(){scrim.classList.add('open');modal.classList.add('open');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
    function close(){scrim.classList.remove('open');modal.classList.remove('open');modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}
    root.querySelectorAll('[data-bys-open]').forEach(function(b){b.addEventListener('click',open);});
    root.querySelectorAll('[data-bys-close]').forEach(function(b){b.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    root.querySelector('[data-bys-add]').addEventListener('click',function(){
      var items=[];
      DATA.forEach(function(grp){ if(!grp.items.length) return; var v=chosenVar(grp); if(v&&v.id) items.push({id:v.id,quantity:1}); });
      if(!items.length)return;
      var btn=this, orig=btn.textContent; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(){
          btn.textContent='Added ✓';
          var dest='/cart';
          if(DISCOUNT_CODE){ dest='/discount/'+encodeURIComponent(DISCOUNT_CODE)+'?redirect=/cart'; }
          setTimeout(function(){ window.location.href=dest; },600);
        })
        .catch(function(){ btn.textContent=orig; alert('Sorry, something went wrong adding your set.'); });
    });
    render();
  }
  function boot(){ document.querySelectorAll('.pp-build-your-set').forEach(initRoot); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
